import React, { useEffect, useContext } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import Page from '../../../../layout/Page/Page';
import Button from '../../../../components/bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import ThemeContext from '../../../../contexts/themeContext';
import { userAuth } from '../../../../contexts/userContext';

const NotFoundPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const { darkModeStatus } = useContext(ThemeContext);
	const { token } = useContext(userAuth);

	const storedUser = React.useMemo(() => {
		try {
			const raw = localStorage.getItem('user-auth');
			return raw ? JSON.parse(raw) : null;
		} catch (e) {
			return null;
		}
	}, []);

	const isAuthenticated = Boolean(
		(token && token.session_key) || (storedUser && storedUser.session_key),
	);

	if (
		location.pathname === '/customer_active' ||
		location.pathname.endsWith('/customer_active')
	) {
		return null;
	}

	useEffect(() => {
		if (!isAuthenticated) {
			navigate('/');
		}
	}, [isAuthenticated, navigate]);

	if (!isAuthenticated) return null;

	const bgColor = darkModeStatus ? '#23263a' : '#F5F7FF';
	const accentColor = darkModeStatus ? '#9b74ff' : '#6c5dd3';
	const textColor = darkModeStatus ? '#fff' : '#6c5dd3';
	const lineColor = darkModeStatus ? '#35395a' : '#E9EDF7';

	return (
		<PageWrapper>
			<Page container='fluid'>
				<div
					className='row h-100 align-items-center justify-content-center'
					style={{ minHeight: '60vh' }}>
					<div className='col-12 col-md-8 text-center'>
						<div style={{ maxWidth: 360, margin: '0 auto' }}>
							<svg
								viewBox='0 0 600 400'
								width='100%'
								xmlns='http://www.w3.org/2000/svg'>
								<g fill='none' fillRule='evenodd'>
									<rect width='600' height='400' fill={bgColor} rx='20' />
									<g transform='translate(120 80)'>
										<circle
											cx='160'
											cy='80'
											r='60'
											fill={accentColor}
											opacity='0.15'
										/>
										<path
											d='M40 200 L280 200'
											stroke={lineColor}
											strokeWidth='16'
											strokeLinecap='round'
										/>
										<text
											x='70'
											y='110'
											fontSize='56'
											fill={textColor}
											fontFamily='Arial,Helvetica,sans-serif'>
											404
										</text>
									</g>
								</g>
							</svg>
						</div>

						<h1 className='display-4 fw-bold mt-4'>{t('Page not found')}</h1>
						<p className='text-muted mb-4' style={{ fontSize: '1.25rem' }}>
							{t('The page you are looking for does not exist or has been moved.')}
						</p>

						<div className='d-flex justify-content-center' style={{ gap: 16 }}>
							<Button
								style={{ fontSize: '1.15rem', minWidth: 140 }}
								color='info'
								onClick={() => {
									navigate('/dashboard');
								}}>
								{t('Go to Dashboard')}
							</Button>

							<Button
								style={{ fontSize: '1.15rem', minWidth: 140 }}
								color='danger'
								onClick={() => {
									navigate(-1);
								}}>
								{t('Go back')}
							</Button>
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default NotFoundPage;
